<template>
  <transition name="modal-fade">
    <div id="modalEditBanner" class="dibble-modal">
      <div class="modal small-m">
        <div
          class="modal-dialog modal-form "
          role="document"
          style="width: 600px"
        >
          <div class="modal-content" style="min-width: 600px !important;">
            <div class="modal-header">
              <p class="title-modal">User Details</p>
              <button
                type="button"
                data-dismiss="modal"
                aria-label="Close"
                @click="closeModal"
              >
              <img src="../../../../assets/images/close-dialog.svg" alt="close-icon">
              </button>
            </div>
            <div class="modal-body form-box mt-2">
              <div v-if="isLoadingData">Loading Data...</div>
              <div v-else class="user-modal-content" style="overflow-x: hidden">
                <div class="profile-image" v-if="userData && userData.image">
                  <img :src="userData.image" alt="profile-image" width="150">
                </div>
                <div class="row mt-2 pl-2 pr-2" v-if="userData">
                  <div class="col-md-12">
                    <div class="form-group" v-for="(field, key) in mapFields"
                         :style="field === 'country' && form.state !== '' ? 'display: none' : ''"
                         :key="key">
                      <div v-if="field === 'state'">
                        <label :for="field.replace('_', '-')" v-text="field.replace('_', ' ')" style="text-transform: capitalize"></label>
                        <select class="form-control"
                                id="item-description-dropdown"
                                v-model="form.state">
                          <option v-for="(option, index) in states" :key="index"
                                  v-text="option" :value="index"></option>
                        </select>
                      </div>
                      <div v-if="field === 'country' && form.state === ''">
                        <label :for="field.replace('_', '-')" v-text="field.replace('_', ' ')" style="text-transform: capitalize"></label>
                        <select class="form-control"
                                id="item-description-dropdown"
                                v-model="form.country">
                          <option v-for="(option, index) in countries" :key="index"
                                  v-text="option" :value="index"></option>
                        </select>
                      </div>
                      <div v-if="!dropDownFields.includes(field)">
                        <label :for="field.replace('_', '-')" v-text="field.replace('_', ' ')" style="text-transform: capitalize"></label>
                        <input type="text" class="form-control" :id="field.replace('_', '-')" v-model="form[field]">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div class="d-flex justify-content-center mt-2">
                  <button v-text="'Reservations'" v-if="userData && userData.has_rental_orders"
                          class="btn-dialog btn-sm ok-btn mr-2" @click="goToUserOrderHistory">
                  </button>
                  <button v-text="'Moorage'" v-if="userData && userData.has_moorage_orders"
                          class="btn-dialog btn-sm ok-btn mr-2" @click="goToMooragePayment">
                  </button>
                  <button v-text="'Save'"
                          class="btn-dialog btn-sm ok-btn" @click="saveUserInfo">
                  </button>
                </div>
                <div class="d-flex justify-content-center mt-2">
                  <button v-text="'Driver\'s license'"
                          class="btn-dialog btn-sm ok-btn mr-2" @click="openModalUserDriverLicense">
                  </button>
                  <button v-text="'Boating license'"
                          class="btn-dialog btn-sm ok-btn" @click="openModalUserBoatLicense">
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>

import DibbleJS from "@/dibble";
import DibbleAPI from "@/api";

export default {
  name: "ModalUserDetails",
	props: {
		userId: String
	},
  data() {
    return {
      userData: null,
      isLoadingData: false,
      mapFields: [
        "first_name",
        "last_name",
        "email",
        "phone_number",
        "birthdate",
        "alt_phone_number",
        "emergency_phone_number",
        "street_address",
        "city",
        "state",
        "zip_code",
        "country"
      ],
      dropDownFields: ["state", "country"],
      form: {
        first_name: "",
        last_name: "",
        email: "",
        phone_number: "",
        birthdate: "",
        alt_phone_number: "",
        emergency_phone_number: "",
        street_address: "",
        city: "",
        state: "",
        zip_code: "",
        country: ""
      },
      states: [],
      countries: []
    };
  },
  created() {
    this.getStateAndCountry();
  },
  watch: {
    userData() {
      this.mapFields.forEach(field => {
        this.form[field] = this.userData[field];
      });
    },
  },
  methods: {
    getStateAndCountry() {
      DibbleJS.showLoader()
      DibbleJS.callApiRequest({
        request: DibbleAPI.api.getStateList,
      }, (response) => {
        if (DibbleAPI.isResponseSuccess(response)) {
          this.states = response.states
          this.states[""] = "Outside of the USA";
          DibbleJS.callApiRequest({
            request: DibbleAPI.api.getCountryList,
          }, (response) => {
            DibbleJS.hideLoader()
            if (DibbleAPI.isResponseSuccess(response)) {
              this.countries = response.countries
              delete this.countries['US']
              this.getUserData()
            }
          })
        } else {
          this.closeModal()
          DibbleJS.toastErrorMessage(response.message)
        }
      }, this._onRequestFailed)
    },
    getUserData() {
      this.isLoadingData = true;
      DibbleJS.showLoader()
      DibbleJS.callApiRequest({
        request: DibbleAPI.api.getAppUserProfile,
        user_id: this.userId
      }, (response) => {
        DibbleJS.hideLoader()
        this.isLoadingData = false;
        if (DibbleAPI.isResponseSuccess(response)) {
          this.userData = response
          console.log(this.userData)
        } else {
          this.closeModal()
          DibbleJS.toastErrorMessage(response.message)
        }
      }, this._onRequestFailed)
    },
    saveUserInfo() {
      DibbleJS.showLoader()
      DibbleJS.callApiRequest({
        request: DibbleAPI.api.setAppUserProfile,
        user_id: this.userId,
        ...this.form
      }, (response) => {
        DibbleJS.hideLoader()
        this.isLoadingData = false;
        if (DibbleAPI.isResponseSuccess(response)) {
          DibbleJS.toastSuccessMessage(response.message)
        } else {
          this.closeModal()
          DibbleJS.toastErrorMessage(response.message)
        }
      }, this._onRequestFailed)
    },
    goToUserOrderHistory() {
      this.$router.push(`/rental-history/${this.userId}`)
    },
    _onRequestFailed(error) {
      this.isLoadingData = false
      DibbleJS.hideLoader();
      console.log(error)
      this.closeModal()
      DibbleJS.toastErrorMessage('Something wrong! can not load data');
    },
    openModalUserDriverLicense() {
      this.$emit('openModalUserDriverLicense')
    },
    openModalUserBoatLicense() {
      this.$emit('openModalUserBoatLicense')
    },
    closeModal() {
      this.$emit("close");
    },
    goToMooragePayment() {
      this.$router.push(`/moorage-payment/${this.userId}`)
    }
  },
};
</script>

<style lang="scss" scoped>
	.modal-content {
		min-width: 500px !important;
	}
	.modal-content, .modal-body {
		background: #C2D8DD !important;
		border-radius: 60px !important;
		padding: 10px 20px;
	}
	.modal-header {
		display: flex !important;
		justify-content: space-between !important;
		align-items: center;
		padding: 10px 0px !important;
		border-bottom: 1.5px solid #1C5169;
		margin: 0 20px !important;
		.title-modal {
			font-family: 'Open Sans';
			font-style: normal;
			font-weight: 700;
			font-size: 22px;
			line-height: 22px;
			letter-spacing: 0.01em;
			color: #1C5169;
			margin-top: 0 !important;
		}
		button {
			border: none !important;
			outline: none !important;
			background: initial;
		}
	}
  .user-modal-content {
    max-height: 500px;
    overflow: scroll;
  }
  .btn-dialog.btn-sm {
    font-size: 14px;
    height: 40px;
  }
</style>
